(function () {
  "use strict";

  function initFloatingContactHub() {
    // If {% render 'floating-contact' %} was accidentally placed somewhere
    // that repeats per item (a product-card snippet, a slider template,
    // etc.) instead of exactly once in theme.liquid, the browser ends up
    // with several elements sharing the same id="fc-global" — each one
    // still trapped inside its own product tile / slide, which is exactly
    // what produces a widget that looks "cut in half" behind a product
    // image. Only the first is ever picked up by getElementById, so clean
    // up any extras here.
    var allWidgets = document.querySelectorAll(".fc-widget");
    if (allWidgets.length > 1) {
      for (var w = 1; w < allWidgets.length; w++) {
        if (allWidgets[w].parentNode) {
          allWidgets[w].parentNode.removeChild(allWidgets[w]);
        }
      }
    }

    var widget = document.getElementById("fc-global") || allWidgets[0];
    if (!widget) return;
    if (widget.getAttribute("data-fc-initialized") === "true") return;
    widget.setAttribute("data-fc-initialized", "true");

    // Any ancestor with a CSS transform/filter/perspective (common in
    // carousels, sliders, and page-transition wrappers) becomes the
    // containing block for position: fixed children, which clips the
    // widget instead of letting it float over the whole viewport.
    // Re-parenting it directly under <body> guarantees it always sits
    // relative to the real viewport.
    if (widget.parentElement !== document.body) {
      document.body.appendChild(widget);
    }

    var bubble = widget.querySelector(".fc-bubble");
    var panel = widget.querySelector(".fc-panel");
    if (!bubble || !panel) return;

    var isOpen = false;
    var bounceTimeout = null;

    function setState(open) {
      isOpen = open;
      widget.setAttribute("data-state", open ? "open" : "closed");
      bubble.setAttribute("aria-expanded", open ? "true" : "false");
      panel.setAttribute("aria-hidden", open ? "false" : "true");
    }

    function playBounce() {
      bubble.classList.remove("fc-anim-bounce-active");
      // Force reflow so the animation restarts on rapid re-clicks.
      void bubble.offsetWidth;
      bubble.classList.add("fc-anim-bounce-active");

      if (bounceTimeout) {
        clearTimeout(bounceTimeout);
      }
      bounceTimeout = setTimeout(function () {
        bubble.classList.remove("fc-anim-bounce-active");
        bounceTimeout = null;
      }, 500);
    }

    function openPanel() {
      if (isOpen) return;
      setState(true);
      playBounce();
    }

    function closePanel() {
      if (!isOpen) return;
      setState(false);
      playBounce();
    }

    function togglePanel() {
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    }

    function handleBubbleActivate(e) {
      e.preventDefault();
      togglePanel();
    }

    function handleOutsideInteraction(e) {
      if (!isOpen) return;
      if (widget.contains(e.target)) return;
      closePanel();
    }

    function handleKeydown(e) {
      if (e.key === "Escape" || e.key === "Esc") {
        if (isOpen) {
          closePanel();
          bubble.focus();
        }
      }
    }

    bubble.addEventListener("click", handleBubbleActivate);

    // Explicit touch support in addition to click (click already fires on
    // tap in all modern mobile browsers, but this keeps interaction snappy
    // and avoids any 300ms delay on older WebViews).
    bubble.addEventListener(
      "touchend",
      function (e) {
        handleBubbleActivate(e);
      },
      { passive: false }
    );

    document.addEventListener("click", handleOutsideInteraction, true);
    document.addEventListener("touchstart", handleOutsideInteraction, true);
    document.addEventListener("keydown", handleKeydown);

    // Initialize closed state explicitly.
    setState(false);

    // --- Robust horizontal positioning ------------------------------------
    // On iOS Safari, position: fixed elements anchored with `right` can be
    // clipped/mis-measured when a body/html ancestor has overflow-x: hidden
    // (extremely common in Shopify themes to hide carousel overflow). Force
    // an explicit pixel `left` instead so the widget is never at the mercy
    // of that bug.
    var isRightPosition = widget.classList.contains("fc-position-right");

    function applyExplicitPosition() {
      var sideSpacing = parseFloat(getComputedStyle(widget).getPropertyValue("--fc-side")) || 24;
      var widgetWidth = widget.getBoundingClientRect().width || bubble.offsetWidth || 60;
      var viewportWidth = document.documentElement.clientWidth || window.innerWidth;

      if (isRightPosition) {
        var leftPx = viewportWidth - widgetWidth - sideSpacing;
        if (leftPx < 4) leftPx = 4;
        widget.style.left = leftPx + "px";
        widget.style.right = "auto";
      } else {
        widget.style.left = sideSpacing + "px";
        widget.style.right = "auto";
      }
    }

    applyExplicitPosition();

    var resizeRaf = null;
    function handleResize() {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        applyExplicitPosition();
        resizeRaf = null;
      });
    }

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    // --- Greeting popup ---------------------------------------------------
    var greeting = widget.querySelector(".fc-greeting");
    var greetingCloseBtn = null;
    var greetingTimer = null;
    var handleGreetingClose = null;

    if (greeting) {
      greetingCloseBtn = greeting.querySelector(".fc-greeting-close");

      var delaySeconds = parseFloat(widget.getAttribute("data-greeting-delay"));
      if (isNaN(delaySeconds) || delaySeconds < 0) delaySeconds = 3;

      greetingTimer = setTimeout(function () {
        if (!isOpen) {
          greeting.classList.add("fc-greeting-visible");
        }
        greetingTimer = null;
      }, delaySeconds * 1000);

      handleGreetingClose = function (e) {
        e.preventDefault();
        e.stopPropagation();
        greeting.classList.remove("fc-greeting-visible");
      };

      if (greetingCloseBtn) {
        greetingCloseBtn.addEventListener("click", handleGreetingClose);
      }
    }

    // Store teardown so Shopify Theme Editor reloads don't leak listeners.
    widget.__fcTeardown = function () {
      bubble.removeEventListener("click", handleBubbleActivate);
      bubble.removeEventListener("touchend", handleBubbleActivate);
      document.removeEventListener("click", handleOutsideInteraction, true);
      document.removeEventListener("touchstart", handleOutsideInteraction, true);
      document.removeEventListener("keydown", handleKeydown);
      if (bounceTimeout) {
        clearTimeout(bounceTimeout);
        bounceTimeout = null;
      }
      if (greetingTimer) {
        clearTimeout(greetingTimer);
        greetingTimer = null;
      }
      if (greetingCloseBtn && handleGreetingClose) {
        greetingCloseBtn.removeEventListener("click", handleGreetingClose);
      }
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
      if (resizeRaf) {
        cancelAnimationFrame(resizeRaf);
        resizeRaf = null;
      }
      widget.removeAttribute("data-fc-initialized");
      delete widget.__fcTeardown;
    };
  }

  function teardownFloatingContactHub() {
    var widget = document.getElementById("fc-global");
    if (widget && typeof widget.__fcTeardown === "function") {
      widget.__fcTeardown();
    }
  }

  document.addEventListener("DOMContentLoaded", initFloatingContactHub);

  // Shopify Theme Editor lifecycle hooks. The widget lives outside the
  // section system, but the editor can still re-render the DOM around it
  // (e.g. on full page refreshes triggered by unrelated section edits),
  // so guard re-init and clean up defensively rather than relying on a
  // specific section id.
  document.addEventListener("shopify:section:load", initFloatingContactHub);
  document.addEventListener("shopify:section:unload", teardownFloatingContactHub);

  // In case this script runs after DOMContentLoaded already fired
  // (e.g. deferred/async loading order in theme.liquid).
  if (document.readyState === "interactive" || document.readyState === "complete") {
    initFloatingContactHub();
  }
})();